import React from 'react';
import { Wrap } from '../item/styled';
import Loading from '../../app/inline-loading';

export default () => <Wrap style={{ padding: '40px 0' }}><Loading /></Wrap>;
